import _ from 'lodash';
import classNames from 'classnames';
import React, { Component, PropTypes } from 'react';
import { Col } from 'react-bootstrap';
import { readComponentInstanceResourceList } from 'lib/frankly';
import { buildQueryString } from 'utils/UrlUtils';
import ComponentContainer from 'components/core/ComponentContainer';
import Image from 'components/Image';
import GridIcon from 'components/icons/Grid';
import Ellipsis from 'components/icons/Ellipsis';
import SponsorArea from '../ads/SponsorArea';
import { isPositionStickySupported } from 'utils/DOMUtils';


const RESULT_TYPE_PARAM = '1,2';

const SearchResultType = {
  '1': 'story',
  '2': 'clip'
};

const TextAlignHeaderType = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};

const MOBILE_SCREENSIZE = 768;

const getNumberOfMenuItems = (array, outerWidth, initialWidth) => {
  let total = initialWidth;

  for (let i = 0; i < array.length; i++) {
    if (total + array[i] > outerWidth) {
      return i - 1;
    } else {
      total += array[i];
    }
  }

  return array.length;
};

const getMenuItemWidthList = (menuItems) => {
  if (window.innerWidth >= MOBILE_SCREENSIZE) {
    return Array.from(menuItems).map(item => item.getBoundingClientRect().width);
  }

  return [];
};

class Header extends Component {
  static propTypes = {
    FRN_componentInstanceId: PropTypes.string,
    enableSearch: PropTypes.bool,
    backgroundColor: PropTypes.string,
    searchIconColor: PropTypes.string,
    subNavstackBackgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    borderOptions: PropTypes.shape({
      top: PropTypes.object,
      botom: PropTypes.object
    }),
    menuItemStyle: PropTypes.object,
    menuItemHoverStyle: PropTypes.object,
    searchOptions: PropTypes.shape({
      numberItems: PropTypes.number,
      backgroundColor: PropTypes.string,
      hoverBackgroundColor: PropTypes.string,
      textColor: PropTypes.string,
      textAlignment: PropTypes.string,
      searchTextColor: PropTypes.string,
      displayResultsOnNewPage: PropTypes.bool
    }),
    menu: PropTypes.array,
    collapseNavigation: PropTypes.bool,
    weatherWidget: PropTypes.object,
    gridIconColor: PropTypes.string,
    enableDropDownMenu: PropTypes.bool,
    enableStaticNavigation: PropTypes.bool,
    staticNavigationOptions: PropTypes.shape({
      backgroundColor: PropTypes.string,
      textColor: PropTypes.string,
      menuItemHoverStyle: PropTypes.object
    }),
    sponsor: PropTypes.object
  }

  static contextTypes = {
    config: PropTypes.object.isRequired
  }

  static defaultProps = {
    enableSearch: true,
    backgroundColor: '#FFF',
    searchIconColor: '#000',
    subNavstackBackgroundColor: '#FFF',
    textColor: '#000',
    borderOptions: {
      top: {
        enable: true,
        color: '#de2828'
      },
      bottom: {
        enable: true,
        color: '#de2828'
      }
    },
    menuItemHoverStyle: {},
    menuItemStyle: {},
    searchOptions: {
      numberItems: 10,
      backgroundColor: '#FFF',
      textColor: '#000',
      textAlignment: TextAlignHeaderType.RIGHT,
      displayResultsOnNewPage: true
    },
    collapseNavigation: false,
    gridIconColor: '#000',
    enableDropDownMenu: true,
    staticNavigationOptions: {
      backgroundColor: '#ccc',
      textColor: '#000',
      menuItemHoverStyle: {}
    }
  }

  state = {
    collapsed: false,
    showMobileSearchBar: false
  }

  componentDidMount() {
    if (this.props.collapseNavigation) {
       window.addEventListener('scroll', () => this._onScroll());
       window.addEventListener('resize', () => this._onResize());
    }
  }

  componentWillUnmount() {
    if (this.props.collapseNavigation) {
      window.removeEventListener('scroll', () => this._onScroll());
      window.addEventListener('resize', () => this._onResize());
    }
  }

  _onScroll() {
    // TODO: Update stickyheader for mobile
    if (window.innerWidth >= MOBILE_SCREENSIZE) {
      let { menuOffsetTop } = this.state;
      let paddingTop = '0px';
      const pageYOffset = window.pageYOffset;
      const navbar = document.getElementById('navbar');
      const page = document.getElementById('page');
      const viewPort = document.documentElement.clientHeight;
      if (!menuOffsetTop) {
        const pageBody = document.querySelector('.PageBody');
        menuOffsetTop = navbar.getBoundingClientRect().top;
        this.state.menuOffsetTop = menuOffsetTop;
        const remnantsOfThePageAfterMenuCollapsed = page.offsetHeight - (viewPort + menuOffsetTop);
        if (remnantsOfThePageAfterMenuCollapsed < menuOffsetTop) {
          const minHeightOfPage = viewPort + menuOffsetTop + navbar.offsetHeight + (menuOffsetTop - remnantsOfThePageAfterMenuCollapsed);
          const additionalHeight = minHeightOfPage - page.offsetHeight;
          pageBody.style.minHeight = pageBody.offsetHeight + additionalHeight + 'px';
        }
      }

      const collapsed = pageYOffset >= menuOffsetTop;

      if (collapsed) {
        paddingTop = navbar.offsetHeight + 'px';
      } else {
        if (!isPositionStickySupported()) {
          const header = document.getElementById('header');
          paddingTop = header.getBoundingClientRect().top + header.offsetHeight - pageYOffset + 'px';
        }
      }
      page.style.paddingTop = paddingTop;
      const userAgent = navigator.userAgent.toLowerCase();
      // fix bug: the extra white space at the bottom  when scroll down the end of the page on Safari
      if (userAgent.indexOf('safari') > -1 && userAgent.indexOf('chrome') < 0) {
        const pageYOffsetMax = page.offsetHeight - viewPort;
        if (pageYOffset > pageYOffsetMax) {
          window.scrollTo(0, pageYOffsetMax);
        }
      }

      this.setState({
        collapsed
      });
    }
  }

  // TODO: Update stickyheader for mobile
  _onResize() {
    if (window.innerWidth < MOBILE_SCREENSIZE) {
      const page = document.getElementById('page');
      page.style.paddingTop = '0px';

      this.setState({
        collapsed: false
      });
    }
  }

  _toggleMobileSearchBar() {
    this.setState({showMobileSearchBar: !this.state.showMobileSearchBar});
  }

  _hideMobileSearchBar() {
    this.setState({showMobileSearchBar: false});
  }

  _getMenuItem(menu) {
    for (let item of menu) {
      const { href, menu: submenu = [] } = item;

      let result;

      if (this._matchPathname(href)) {
        return item;
      } else {
        if (submenu.length) {
          result = this._getMenuItem(submenu);
        }
      }

      if (result) {
        return item;
      }
    }
  }

  _matchPathname(href) {
    //return window && (location.pathname === href);
    return typeof window !== 'undefined' ? location.pathname === href : false;
  }

  render() {
    const {
      config: {
        affiliate: {
          logo = ''
          } = {}
        } = {}
      } = this.context;

    const {
      FRN_componentInstanceId,
      menu: menuItems = [],
      weatherWidget: weatherWidgetComponentDefinition,
      borderOptions: {
        top: {
          enable: enableBorderTop,
          color: borderTopColor
        },
        bottom: {
          enable: enableBorderBottom,
          color: borderBottomColor
        }
      },
      enableSearch,
      searchIconColor,
      searchOptions,
      backgroundColor,
      textColor,
      menuItemStyle,
      menuItemHoverStyle,
      subNavstackBackgroundColor,
      gridIconColor,
      enableDropDownMenu,
      enableStaticNavigation,
      staticNavigationOptions,
      sponsor
    } = this.props;

    const {
      collapsed,
      showMobileSearchBar
    } = this.state;

    const { backgroundColor: activeItemColor } = staticNavigationOptions;

    const className = classNames('CollapsibleHeader', {'CollapsibleHeader-collapse CollapsibleHeader--sticky': collapsed});
    const componentStyle = {
      borderTop: enableBorderTop ? `3px solid ${borderTopColor}` : '',
      borderBottom: enableBorderBottom ? `1px solid ${borderBottomColor}` : '',
      backgroundColor
    };

    const staticNavigationMenuItems = this._getMenuItem(menuItems);
    const { href: activeItem } = staticNavigationMenuItems || {};

    return (
      <div className={className} style={componentStyle}>
        <div className="container" >
          <Col xl={4} lg={4} md={5} sm={5} className="CollapsibleHeader-logo">
              <a href="/">
                <Image height="70" src={logo} alt="logo" forceDPR />
              </a>
          </Col>
          <Col xl={8} lg={8} md={7} sm={7} xs={12}>
            <div className="CollapsibleHeader-toggleIcon" >
              <div type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" onClick={() => this._hideMobileSearchBar()}>
                <svg x="0px" y="0px" width="20px" height="20px" viewBox="0 0 36 36" xmlSpace="preserve">
                  <line stroke={gridIconColor} x1="12" y1="18" x2="32" y2="18"/>
                  <line stroke={gridIconColor} x1="4" y1="6" x2="32" y2="6"/>
                  <line stroke={gridIconColor} x1="20" y1="30" x2="32" y2="30"/>
                </svg>
              </div>
            </div>
            <HeaderMenu
              headerContext={this}
              weatherWidgetComponentDefinition={weatherWidgetComponentDefinition}
              FRN_componentInstanceId={FRN_componentInstanceId}
              menuItems={menuItems}
              collapsed={collapsed}
              enableSearch={enableSearch}
              searchIconColor={searchIconColor}
              textColor={textColor}
              subNavstackBackgroundColor={subNavstackBackgroundColor}
              menuItemHoverStyle={menuItemHoverStyle}
              menuItemStyle={menuItemStyle}
              toggleMobileSearchBar = {() => this._toggleMobileSearchBar()}
              showMobileSearchBar={showMobileSearchBar}
              backgroundColor={backgroundColor}
              searchOptions={searchOptions}
              gridIconColor={gridIconColor}
              enableDropDownMenu={enableDropDownMenu}
              activeItemColor={activeItemColor}
              enableStaticNavigation={enableStaticNavigation}
              activeItem={activeItem}
              sponsor={sponsor}
            />
          </Col>
        </div>
        {
          enableStaticNavigation && <StaticNavigation
                MenuItems={staticNavigationMenuItems}
                {...staticNavigationOptions}
              />
        }
      </div>
    );
  }
}

class HeaderMenu extends Component {
  static propTypes = {
    menuItems: PropTypes.array,
    collapsed: PropTypes.bool,
    headerContext: PropTypes.object,
    weatherWidgetComponentDefinition: PropTypes.object,
    FRN_componentInstanceId: PropTypes.string,
    enableSearch: PropTypes.bool,
    searchIconColor: PropTypes.string,
    textColor: PropTypes.string,
    subNavstackBackgroundColor: PropTypes.string,
    menuItemHoverStyle: PropTypes.object,
    menuItemStyle: PropTypes.object,
    toggleMobileSearchBar: PropTypes.func,
    showMobileSearchBar: PropTypes.bool,
    backgroundColor: PropTypes.string,
    searchOptions: PropTypes.object,
    gridIconColor: PropTypes.string,
    enableDropDownMenu: PropTypes.bool,
    activeItemColor: PropTypes.string,
    enableStaticNavigation: PropTypes.bool,
    activeItem: PropTypes.string,
    sponsor: PropTypes.object
  }

  static defaultProps = {
    menuItems: []
  }

  state = {
    priorityItems: this.props.menuItems,
    moreItems: [],
    isHidden: true,
  }

  componentDidMount() {
    //Get width of all items in navigation menu
    this.menuItemWidthList = getMenuItemWidthList(this.navigation.children);
    this._updateNavigation();
    window.addEventListener('resize', () => this._updateNavigation());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.collapsed !== this.props.collapsed) {
      this._updateNavigation();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this._updateNavigation());
  }

  _onClickSearchMenuItem() {
    this.props.toggleMobileSearchBar();

    window['$']('body').animate({ scrollTop: 0 }, 500);
  }

  _updateNavigation() {
    // Spare space for transition: more icon(55px) and buffer(25px)
    const WIDTH_LEFT = 80;

    const { menuItems, collapsed } = this.props;
    const outerWidth = this.navigationOuter.getBoundingClientRect().width;
    const headerSearchWidth = this.headerSearch ? this.headerSearch.getBoundingClientRect().width : 0;

    let condensedWeatherWidth = 0;
    let priorityItems;
    let moreItems;

    if (!this.menuItemWidthList.length) {
      this.menuItemWidthList = getMenuItemWidthList(this.navigation.children);
    }

    if (collapsed) {
      condensedWeatherWidth = this.condensedWeather ? this.condensedWeather.getBoundingClientRect().width : 0;
    }

    const menuItemsLength = getNumberOfMenuItems(this.menuItemWidthList, outerWidth, headerSearchWidth + condensedWeatherWidth + WIDTH_LEFT);

    if (menuItems.length === menuItemsLength || window.innerWidth < MOBILE_SCREENSIZE) {
      priorityItems = menuItems;
      moreItems = [];
    } else {
      priorityItems = menuItems.slice(0, menuItemsLength + 1);
      moreItems = menuItems.slice(menuItemsLength + 1, menuItems.length);
    }

    this.setState({
      priorityItems,
      moreItems,
      isHidden: false
    });
  }

  render() {
    const {
      priorityItems,
      moreItems,
      isHidden,
    } = this.state;

    const {
      collapsed,
      headerContext,
      weatherWidgetComponentDefinition,
      FRN_componentInstanceId,
      enableSearch,
      searchIconColor,
      searchOptions: {
        numberItems: numberOfSearchItems,
        backgroundColor: searchBackgroundColor,
        textColor: searchTextColor,
        textAlignment: searchTextAlignment,
        displayResultsOnNewPage
      },
      menuItemHoverStyle,
      menuItemStyle,
      subNavstackBackgroundColor,
      textColor,
      toggleMobileSearchBar,
      showMobileSearchBar,
      gridIconColor,
      enableDropDownMenu,
      activeItemColor,
      enableStaticNavigation,
      activeItem,
      sponsor
    } = this.props;

    if (weatherWidgetComponentDefinition) {
      _.assign(weatherWidgetComponentDefinition.props, { condensed: collapsed, showDetail: true });
    }

    const topHeaderClassName = classNames('CollapsibleHeader-topHeader', {
      'CollapsibleHeader-topHeader--collapse': collapsed,
      'CollapsibleHeader-topHeader--collapse-weatherWidget': weatherWidgetComponentDefinition && collapsed
    });

    const styleOfSponsorArea = {
      display: collapsed ? 'none' : null
    };

    return (
      <div className="HeaderMenu clearfix" ref={(navigationOuter) => { this.navigationOuter = navigationOuter; }}>
        <div className={topHeaderClassName} ref={(condensedWeather) => { this.condensedWeather = condensedWeather; }}>
          {
            weatherWidgetComponentDefinition && <ComponentContainer
              componentDefinition={weatherWidgetComponentDefinition}
              componentInstanceId={`${FRN_componentInstanceId}.props.weatherWidget`}
              condensed={collapsed}
            />
          }
          <div className="Collapsible-HeaderMenu-SponsorArea" style={styleOfSponsorArea}>
            <SponsorArea sponsor={sponsor}/>
          </div>
        </div>
        {
          enableSearch &&
          <div className="HeaderMenu-SearchBar hidden-xs" ref={(headerSearch) => { this.headerSearch = headerSearch; }}>
            <HeaderSearch
              headerContext={headerContext}
              numberOfSearchItems={numberOfSearchItems}
              searchBackgroundColor={searchBackgroundColor}
              searchTextColor={searchTextColor}
              searchTextAlignment={searchTextAlignment}
              displayResultsOnNewPage={displayResultsOnNewPage}
              searchIconColor={searchIconColor}
            />
          </div>
        }
        <div id="navbar-collapse" className="navbar-collapse collapse" aria-expanded="false">
          <ul id="navbar" className={`nav navbar-nav ${isHidden && 'isHidden'}`} ref={(navigation) => { this.navigation = navigation; }}>
            {
              priorityItems.map((item, index) => (
                <MenuItem
                  key={index}
                  item={item}
                  textColor={textColor}
                  subNavstackBackgroundColor={subNavstackBackgroundColor}
                  menuItemHoverStyle={menuItemHoverStyle}
                  menuItemStyle={menuItemStyle}
                  enableDropDownMenu={enableDropDownMenu}
                  activeItemColor={activeItemColor}
                  enableStaticNavigation={enableStaticNavigation}
                  activeItem={activeItem}
                />
              ))
            }
            { moreItems.length > 0 &&
              <li className="dropdown hambuger">
                <CustomAnchor hoverStyle={menuItemHoverStyle}>
                  <GridIcon color={gridIconColor}/>
                </CustomAnchor>
                  <ul className="dropdown-menu dropdown-menu-more" style={{backgroundColor: subNavstackBackgroundColor}}>
                    {
                      moreItems.map((item, index) => (
                        <MenuItem
                          key={index}
                          item={item}
                          textColor={textColor}
                          subNavstackBackgroundColor={subNavstackBackgroundColor}
                          menuItemHoverStyle={menuItemHoverStyle}
                          menuItemStyle={menuItemStyle}
                          enableDropDownMenu={enableDropDownMenu}
                          submenu
                          more
                        />
                      ))
                    }
                  </ul>
              </li>
            }
            {
              <li className="HeaderMenu-search"
                data-toggle="collapse" data-target="#navbar-collapse"
                onClick={() => this._onClickSearchMenuItem()}>
                <a style={{color: textColor}}>
                  <i className="fa fa-search" aria-hidden="true"></i> Search
                </a>
              </li>
            }
          </ul>
        </div>
        {showMobileSearchBar &&
          <div className="HeaderMenu-MobileHeaderSearch">
            <MobileHeaderSearch
              headerContext={headerContext}
              toggleMobileSearchBar={() => toggleMobileSearchBar()}
              numberOfSearchItems={numberOfSearchItems}
              searchBackgroundColor={searchBackgroundColor}
              searchTextColor={searchTextColor}
              searchTextAlignment={searchTextAlignment}
              displayResultsOnNewPage={displayResultsOnNewPage}
            />
          </div>
        }
      </div>
    );
  }
}

class MenuItem extends Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
    submenu: PropTypes.bool,
    more: PropTypes.bool,
    subNavstackBackgroundColor: PropTypes.string,
    menuItemHoverStyle: PropTypes.object,
    menuItemStyle: PropTypes.object,
    textColor: PropTypes.string,
    enableDropDownMenu: PropTypes.bool,
    activeItemColor: PropTypes.string,
    enableStaticNavigation: PropTypes.bool,
    activeItem: PropTypes.string
  }

  render() {
    const {
      item: {
        text,
        href,
        target = '_self',
        liveOptions,
        menu = []
      },
      submenu,
      more,
      subNavstackBackgroundColor,
      menuItemHoverStyle,
      menuItemStyle,
      textColor,
      enableDropDownMenu,
      activeItemColor,
      enableStaticNavigation,
      activeItem
    } = this.props;

    const menuItemComponents = menu.map((item, i) => {
      return (
        <MenuItem
          key={i}
          item={item}
          submenu
          more={more}
          textColor={textColor}
          subNavstackBackgroundColor={subNavstackBackgroundColor}
          menuItemHoverStyle={menuItemHoverStyle}
          menuItemStyle={menuItemStyle}
          enableDropDownMenu={enableDropDownMenu} />
      );
    });

    const menuItemClassNames = classNames(
      {
        'dropdown': menuItemComponents.length && !submenu,
        'dropdown-submenu': menuItemComponents.length && submenu && enableDropDownMenu
      }
    );

    const submenuItemsClassNames = classNames(
      'dropdown-menu',
      {
        'dropdown-submenu-more': menuItemComponents.length && more
      }
    );

    const style = {
      color: textColor,
      ...menuItemStyle,
      backgroundColor: submenu ? subNavstackBackgroundColor : menuItemStyle.backgroundColor
    };

    const isActiveMenuItem = menuItemComponents.length && enableStaticNavigation && activeItem === href;
    const activeClassName = classNames({ 'active': isActiveMenuItem });
    /*eslint-disable no-script-url*/
    const customAnchor = [<CustomAnchor
      key="0"
      href={href}
      style={style}
      target={target}
      liveOptions={liveOptions}
      hoverStyle={menuItemHoverStyle}>{text}</CustomAnchor>,
      isActiveMenuItem ? <div key="1" className={activeClassName} style={{ backgroundColor: activeItemColor }}></div> : ''];

    const menuLink = submenu ? <CustomAnchor
        href={href ? href : "javascript: void(0);"}
        style={style}
        hoverStyle={menuItemHoverStyle}>
          {text}
        </CustomAnchor> : [
        customAnchor,
        <CustomAnchor
          key="2"
          data-toggle="dropdown"
          aria-expanded="false"
          style={{color: textColor}}
          className="HeaderMenu-topMenuDropdownIcon">
          <span className="caret hidden-sm"></span>
        </CustomAnchor>
      ];
    /*eslint-enable no-script-url*/
    const submenuItemsStyle = {
      backgroundColor: subNavstackBackgroundColor
    };

    return (
      <li className={menuItemClassNames}>
        { menuItemComponents.length ? menuLink : customAnchor }
        {
          menuItemComponents.length > 0 && enableDropDownMenu &&
          <ul style={submenuItemsStyle} className={submenuItemsClassNames}>
            {menuItemComponents}
          </ul>
        }
      </li>
    );
  }
}

class HeaderSearch extends Component {
  static propTypes = {
    numberOfSearchItems: PropTypes.number,
    searchBackgroundColor: PropTypes.string,
    searchTextColor: PropTypes.string,
    searchTextAlignment: PropTypes.string,
    headerContext: PropTypes.object,
    displayResultsOnNewPage: PropTypes.bool,
    searchIconColor: PropTypes.string
  }

  static defaultProps = {
    numberOfSearchItems: 10,
    searchBackgroundColor: '#e68f8f',
    searchTextColor: '#000',
    searchTextAlignment: TextAlignHeaderType.RIGHT,
    displayResultsOnNewPage: false,
    searchIconColor: '#000'
  }

  state = {
    showSearchBar: false
  }

  _toggleSearchBar() {
    this.setState({
      showSearchBar: !this.state.showSearchBar,
      searchResults: {}
    });
  }

  render() {
    const {
      numberOfSearchItems,
      searchBackgroundColor,
      searchTextColor,
      searchTextAlignment,
      headerContext,
      displayResultsOnNewPage,
      searchIconColor
    } = this.props;

    const { showSearchBar } = this.state;

    return (
      <div className="HeaderSearch hidden-xs" style={{color: searchIconColor}}>
        <button className="HeaderSearch-icon" onClick={() => this._toggleSearchBar()}>
          {!showSearchBar ? <i className="fa fa-search" aria-hidden="true"></i>
            : <i className="fa fa-times" aria-hidden="true"></i>}
        </button>
        {showSearchBar ?
          <SearchBar
            numberOfSearchItems={numberOfSearchItems}
            searchBackgroundColor={searchBackgroundColor}
            searchTextColor={searchTextColor}
            searchTextAlignment={searchTextAlignment}
            headerContext={headerContext}
            displayResultsOnNewPage={displayResultsOnNewPage}
          /> : null}
      </div>
    );
  }
}

class MobileHeaderSearch extends Component {
  static propTypes = {
    numberOfSearchItems: PropTypes.number,
    searchBackgroundColor: PropTypes.string,
    searchTextColor: PropTypes.string,
    searchTextAlignment: PropTypes.string,
    toggleMobileSearchBar: PropTypes.func.isRequired,
    headerContext: PropTypes.object,
    displayResultsOnNewPage: PropTypes.bool
  }

  static defaultProps = {
    numberOfSearchItems: 10,
    searchBackgroundColor: '#e68f8f',
    searchTextColor: '#000',
    searchTextAlignment: TextAlignHeaderType.RIGHT,
    displayResultsOnNewPage: false
  }

  render() {
    const {
      numberOfSearchItems,
      searchBackgroundColor,
      searchTextColor,
      searchTextAlignment,
      toggleMobileSearchBar,
      headerContext,
      displayResultsOnNewPage
    } = this.props;

    return (
      <div className="MobileHeaderSearch hidden-md hidden-lg hidden-sm" style={{color: searchTextColor}}>
        <div style={{backgroundColor: searchBackgroundColor}}>
          <div className="MobileHeaderSearch-cancelIcon"><i data-toggle="collapse" data-target="#navbar-collapse" className="fa fa-times" onClick={() => toggleMobileSearchBar()}/></div>
          <SearchBar
            numberOfSearchItems={numberOfSearchItems}
            searchBackgroundColor={searchBackgroundColor}
            searchTextColor={searchTextColor}
            searchTextAlignment={searchTextAlignment}
            headerContext={headerContext}
            displayResultsOnNewPage={displayResultsOnNewPage}
          />
        </div>
      </div>
    );
  }
}

class SearchBar extends Component {
  static propTypes = {
    numberOfSearchItems: PropTypes.number,
    searchBackgroundColor: PropTypes.string,
    searchTextColor: PropTypes.string,
    searchTextAlignment: PropTypes.string,
    headerContext: PropTypes.object,
    displayResultsOnNewPage: PropTypes.bool
  }

  static contextTypes = {
    config: PropTypes.object.isRequired
  }

  static defaultProps = {
    numberOfSearchItems: 10,
    searchBackgroundColor: '#FFF',
    searchTextColor: '#000',
    searchTextAlignment: TextAlignHeaderType.RIGHT,
    displayResultsOnNewPage: false
  }

  state = {
    searchResults: null
  }

  componentDidMount() {
    this.searchInput.focus();
  }

  _searchKeyEnter(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      this._search();
    }
  }

  _search() {
    const { innerText: value } = this.searchInput;
    if (value.length > 1) {
      this._getData(value);
    } else {
      this.setState({ searchResults: {} });
    }
  }

  _getData(value) {
    const {
      config: {
        affiliate: {
          id
          } = {}
        } = {}
      } = this.context;
    const {
      numberOfSearchItems,
      headerContext,
      displayResultsOnNewPage
    } = this.props;
    const searchParams = {
      affiliateno: id,
      resulttype: RESULT_TYPE_PARAM,
      qu: value,
      num: numberOfSearchItems
    };

    const searchParamsString = buildQueryString(searchParams);

    if (displayResultsOnNewPage){
      const href = location.protocol + '//' + location.hostname
        + (location.port ? ':' + location.port : '')
        + '/search?qu=' + value + '&num=' + numberOfSearchItems;
      location.href = href;
    } else {
      readComponentInstanceResourceList(headerContext, { propPath: `searchOptions`, vars: { params: searchParamsString } }).then(rawResponse => {
        this.setState({ searchResults: rawResponse[0] });
      }).catch(() => {
        this.setState({ searchResults: {} });
      });
    }
  }

  render() {
    const {
      searchBackgroundColor,
      searchTextColor,
      searchTextAlignment
    } = this.props;

    const {
      searchResults
    } = this.state;

    const componentStyle = {
      backgroundColor: searchBackgroundColor,
      color: searchTextColor
    };

    let searchContent = [];
    if (searchResults) {
      const {
        data: {
          SEARCH: {
            RESULTS: {
              RESULT: results = []
            } = {}
          } = {}
        } = {}
      } = searchResults;

      searchContent = results.map((item, index) => {
        const { SEO: {
          PAGEURL = ''
          } = {}
        } = item;

        const rootPath = SearchResultType[item.SEARCHRESULTTYPE];

        if (!rootPath) {
          return null;
        }

        return (
          <li key={index} style={{textAlign: searchTextAlignment}}>
            <a href={`/${rootPath}/${item.TITLE}/${PAGEURL}`}>{item.HEADLINE}</a>
          </li>
        );
      });
    }

    if (searchContent.length) {
        searchContent.unshift(<li key='results' style={{textAlign: searchTextAlignment}}>Results</li>);
    }

    return (
      <div className="SearchBar" style={componentStyle}>
        <div className="input-group">
          <div className="SearchBar-input">
            <div
              contentEditable
              ref={ (searchInput) => { this.searchInput = searchInput;} }
              onKeyPress={(e) => this._searchKeyEnter(e)}
              placeholder="Enter text here..."></div>
          </div>
          <span className="input-group-btn">
            <button onClick={() => this._search()}>GO</button>
          </span>
        </div>
        <ul className="SearchBar-result" style={componentStyle}>
          {searchContent}
        </ul>
      </div>
    );
  }
}

class CustomAnchor extends Component {
  static propTypes = {
    href: PropTypes.string,
    style: PropTypes.object,
    hoverStyle: PropTypes.object,
    liveOptions: PropTypes.object,
    children: PropTypes.node
  }

  static defaultProps = {
    style: {},
    hoverStyle: {}
  }

  state = {
    hover: false
  }

  render() {
    const {
      children,
      style,
      hoverStyle,
      liveOptions: {
        enabled,
        color = 'red'
      } = {},
      ...props
    } = this.props;
    const {
      hover
    } = this.state;

    let mergedStyle = _.clone(style);

    if (hover) {
      mergedStyle = _.assign(mergedStyle, _.mapValues(hoverStyle, val => val));
    }

    return (
      <a
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        {...props}
        style={mergedStyle}>
        {children}
        {enabled && <span className="LiveIcon" style={{ backgroundColor: color }}></span>}
      </a>
    );
  }
}

class StaticNavigation extends Component {
  static propTypes = {
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    menuItemHoverStyle: PropTypes.object,
    MenuItems: PropTypes.object
  }

  render() {
    const {
      backgroundColor,
      textColor,
      menuItemHoverStyle,
      MenuItems
    } = this.props;

    if (!MenuItems) {
      return null;
    }

    const {
      text: title,
      menu: submenu = [],
      href
    } = MenuItems;

    if (!submenu.length){
      return null;
    }

    return (
      <StaticNavigationBar
        menuItems={submenu}
        title={title}
        href={href}
        backgroundColor={backgroundColor}
        textColor={textColor}
        menuItemHoverStyle={menuItemHoverStyle}
      />
    );
  }
}

class StaticNavigationBar extends Component {
  static propTypes = {
    menuItems: PropTypes.array,
    href: PropTypes.string,
    title: PropTypes.string,
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    menuItemHoverStyle: PropTypes.object
  }

  state = {
    priorityItems: this.props.menuItems,
    moreItems: []
  }

  componentDidMount() {
    //Get width of all items in navigation menu
    this.menuItemWidthList = getMenuItemWidthList(this.navigation.children);

    this._updateNavigation();
    window.addEventListener('resize', () => this._updateNavigation());
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this._updateNavigation());
  }

  _updateNavigation() {
    // Spare space for transition: more button(55px) and buffer(65px)
    const WIDTH_LEFT = 120;

    const { menuItems } = this.props;
    const outerWidth = this.navigationOuter.getBoundingClientRect().width;

    let priorityItems;
    let moreItems;

    if (!this.menuItemWidthList.length) {
      this.menuItemWidthList = getMenuItemWidthList(this.navigation.children);
    }

    const menuItemsLength = getNumberOfMenuItems(this.menuItemWidthList, outerWidth, WIDTH_LEFT);

    if (menuItems.length === menuItemsLength || window.innerWidth < MOBILE_SCREENSIZE) {
      priorityItems = menuItems;
      moreItems = [];
    } else {
      priorityItems = menuItems.slice(0, menuItemsLength);
      moreItems = menuItems.slice(menuItemsLength, menuItems.length);
    }

    this.setState({
      priorityItems,
      moreItems
    });
  }

  render() {
    const {
      title,
      href,
      backgroundColor,
      textColor,
      menuItemHoverStyle
    } = this.props;

    const {
      priorityItems,
      moreItems
    } = this.state;

    const staticNavigationStyle = {
      backgroundColor
    };

    return (
      <div className="StaticNavigation" style={staticNavigationStyle}>
        <div className="container">
          <div ref={(navigationOuter) => { this.navigationOuter = navigationOuter; }}>
            <ul className="nav StaticNavigation-SubCategoryMenu" ref={(navigation) => { this.navigation = navigation; }}>
              <li className="StaticNavigation-SubCategoryMenu--title">
                <CustomAnchor
                  href={href}
                  hoverStyle={menuItemHoverStyle}
                  style={{color: textColor}}>
                  {title}
                </CustomAnchor>
              </li>
              {priorityItems.map((item, index) => {
                  return (
                    <MenuItem
                      key={index}
                      item={item}
                      textColor={textColor}
                      menuItemHoverStyle={menuItemHoverStyle}
                      submenu
                      more
                    />
                  );
              })}
              { moreItems.length > 0 &&
              <li className="dropdown hambuger">
                <CustomAnchor hoverStyle={menuItemHoverStyle}>
                  <Ellipsis color={textColor}/>
                </CustomAnchor>
                  <ul className="dropdown-menu dropdown-menu-more" style={{backgroundColor}}>
                    {
                      moreItems.map((item, index) => (
                        <MenuItem
                          key={index}
                          item={item}
                          textColor={textColor}
                          menuItemHoverStyle={menuItemHoverStyle}
                          submenu
                          more
                        />
                      ))
                    }
                  </ul>
              </li>
              }
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./app/components/core/CollapsibleHeader.js